var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "_container" },
    _vm._l(_vm.statuses, function (status) {
      return _c(
        "div",
        { key: status.name, staticClass: "d-flex align-center" },
        [
          status.connected
            ? _c("v-chip", { attrs: { color: "green", outlined: "" } }, [
                _vm._v("Connected"),
              ])
            : _c("v-chip", { attrs: { color: "red", outlined: "" } }, [
                _vm._v("Disconnected"),
              ]),
          _c("span", { staticClass: "my-3 ml-2" }, [
            _vm._v(_vm._s(status.name)),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }